'use strict';

var fetchJSON = require('./fetchJSON.js');

/* eslint-disable no-console */
function mapResponses(services, responses) {
  return Object.keys(services).reduce((acc, key, responseIndex) => {
    const response = responses[responseIndex];
    if (response.status === 'fulfilled') {
      acc[key] = response.value;
    }
    if (response.status === 'rejected') {
      acc[key] = response;
    }
    return acc;
  }, {});
}
async function fetchCompositeJSON(services = {}, options = {
  timeout: 30000
}) {
  const servicePromises = Object.values(services).map(service => {
    if (typeof service === 'string') {
      // If the service is a string we construct a fetch JSON
      return fetchJSON.fetchJSON(service, options);
    }
    return service;
  }).map(promise => promise.catch(error => error));
  return Promise.allSettled(servicePromises).then(responses => mapResponses(services, responses)).catch(error => console.error(error));
}

exports.fetchCompositeJSON = fetchCompositeJSON;
